import { useQuery } from '@tanstack/vue-query';
import { api } from '@/hooks/axios-api';

export const fetchTransactions = async (transactionType:string) => {
  const params = transactionType ? { transaction_type: transactionType } : {};
  const response = await api.get('/tools/transactions/', {params});
  return response.data;
};


////////////////////////////////// HOOKS //////////////////////////// 


export const useFetchTransactions  = (transactType:string) => useQuery({
  queryKey: ["transactions", transactType],
  queryFn: () => fetchTransactions(transactType),
  // refetchInterval: 3000
  refetchOnWindowFocus: true,
});
